<template>
  <div class="md-flex">
    <div class="sidebar flex-none xs-hide sm-hide"></div>
    <div class="flex-auto md-pl2">
      <div v-if="isDesk">
        <image-list :images="deskList" class="m0 smaller"></image-list>
      </div>
      <div v-else v-html="content"></div>
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import ImageList from '@/components/partials/ImageList'

  export default {
    name: 'page',
    computed: {
      page () {
        return this.$store.state.pages[this.$route.params.slug || this.$route.name]
      },
      content () {
        return this.page.content && this.page.content.rendered
      },
      isDesk () {
        return this.$route.name === 'desk'
      },
      deskList () {
        return this.isDesk && this.page.acf.gallery
      }
    },
    beforeRouteEnter (to, from, next) {
      let slug = to.params.slug || to.name.toLowerCase()
      store.dispatch('getPage', slug).then(() => {
        next()
      })
    },
    beforeRouteUpdate (to, from, next) {
      let slug = to.params.slug || to.name.toLowerCase()
      store.dispatch('getPage', slug).then(() => {
        next()
      })
    },
    components: { ImageList }
  }
</script>



// WEBPACK FOOTER //
// src/components/Page.vue